/** Work that outlived its welcome — told apart from work that failed. */
export class TimedOut extends Error {
  constructor() {
    super('Took too long')
    this.name = 'TimedOut'
  }
}

/**
 * Settles with the work, or rejects with `TimedOut` once `ms` have passed — whichever comes
 * first. The work itself is not cancelled; what is bounded is how long anybody waits on it.
 */
export async function withTimeout<T>(work: Promise<T>, ms: number): Promise<T> {
  let timer: ReturnType<typeof setTimeout> | undefined
  try {
    return await Promise.race([
      work,
      new Promise<never>((_, reject) => {
        timer = setTimeout(() => {
          reject(new TimedOut())
        }, ms)
      }),
    ])
  } finally {
    clearTimeout(timer)
  }
}
